<BaseModal
  v-model="isOpen"
  :width="isMobile ? '100%' : '760px'"
  class="free-samples-modal"
  @update:modelValue="$emit('update:modelValue', $event)"
  :bottomSheetOnMobile="isMobile"
  :maxWidth="isMobile ? '100%' : '760px'"
>
  <template #header>{{ $t('products.free_samples.title').replace(/%/g, '') }}</template>

  <div class="free-samples-modal-body">
    <ul class="free-samples-list">
      <li
        v-for="product in freeSamples"
        :key="getBeautyDealId(product)"
        class="free-samples-item"
      >
        <label
          class="free-samples-label"
          :tabindex="isRowDisabled(product) ? -1 : 0"
          @keydown.space.prevent="handleRowClick(product)"
          @keydown.enter.prevent="handleRowClick(product)"
          :class="{ 'is-disabled': isRowDisabled(product) }"
        >
          <input
            type="checkbox"
            :checked="isSelected(product)"
            @change="handleRowClick(product)"
            :disabled="isRowDisabled(product)"
            :data-product-id="getBeautyDealId(product)"
          />
          <span class="free-samples-radio" aria-hidden="true">
            <span v-if="isSelected(product)" class="iconfont-check" />
          </span>
          <span class="free-samples-text">
            <span class="free-samples-brand">{{ brandName(product) }}</span>
            <span class="free-samples-description">{{ productDescription(product) }}</span>
          </span>
          <img
            v-if="product.main_image?.thumb"
            :src="imageUrl(product.main_image.thumb)"
            :alt="product.name || product.title"
            class="free-samples-thumb"
          />
        </label>
      </li>
    </ul>
  </div>

  <template #footer>
    <div class="free-samples-footer">
      <button
        type="button"
        class="checkout-v2-btn"
        :class="{ disabled: saving || !hasLocalChanges }"
        :disabled="saving || !hasLocalChanges"
        @click="save"
      >
        {{ $t('app.free_samples.add_to_cart') }}
      </button>
      <div class="free-samples-counter-bar">
        <span class="free-samples-counter">{{ selectedCount }}/{{ allowedFreeSamples }}</span>
      </div>
    </div>
  </template>
</BaseModal>
